import { getBucketList } from './getBucketList';

export const getBucket = (state, bucketName) => {
    return getBucketList(state).find((item) => item.Name === bucketName);
};
